import { React, useState,useEffect } from "react";
import { Modal, Button,Form, Nav } from "react-bootstrap";
import { useAuth0 } from '@auth0/auth0-react'
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../../store/slices/modal/modalSlice";
import { allTenantsInDb,changeTenant,getAllSuperAdm,createTenant } from "../../../store/slices/roles/rolesThunks";
import { countries } from "../../../helpers/users";
const SuperAdminStatus = () => {
    const dispatch = useDispatch();
    const { allTenants, requestStatus ,allSuperAd} = useSelector((state) => state.roles);
    const  {user} = useSelector( (state) => state.profile );
    const [addTenant, setAddTenant] = useState(false);
    const [messageError,setMessageError] = useState(false);
    const [input, setInput] = useState({
      createdUser:'',
      tenantName:'',
      country:''
    });
    const currentTenant = user[0].tenantname
    const userAuth = useAuth0();
    const adminEmail = userAuth.user.email
    const [selectedOption, setSelectedOption] = useState("default");

  useEffect(()=> {
    dispatch(allTenantsInDb())
    dispatch(getAllSuperAdm())
  },[])

  const handleTenantStatus = () => {    
     dispatch(changeTenant(selectedOption,adminEmail))       
  };
  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.id]: e.target.value,
    });
  
  };
  const submitNewTenant = () => {
   // dispatch(addTenantInDb(input))
   if(input.country&&input.tenantName){
    dispatch(createTenant(input.tenantName ,input.country,adminEmail))
    setAddTenant(false)
   }else{
    setMessageError(true)
    setTimeout(() => {
      setMessageError(false)
    }, 3000);
   }
  
  }

  return ( <>
    <style>{`
      .sa-tabs .nav-link:not(.active) {
        background-color: #f2f2f2;
        color: #495057;
      }
      .sa-input::placeholder {
        color: #adb5bd;
      }
      select.sa-input {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
        background-size: 16px 12px;
        padding-right: 2.25rem;
      }
    `}</style>
    <Modal.Header closeButton>
      <Modal.Title>Manage Tenants</Modal.Title>
    </Modal.Header>
    <Nav variant="tabs" className="sa-tabs" activeKey={addTenant ? "create" : "select"} style={{ paddingLeft: '10px', paddingTop: '10px' }}>
      <Nav.Item>
        <Nav.Link eventKey="select" onClick={() => setAddTenant(false)}>
          Select tenant
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="create" onClick={() => setAddTenant(true)}>
          Create tenant
        </Nav.Link>
      </Nav.Item>
    </Nav>

    {addTenant ? (
    <Modal.Body style={{ minHeight: '480px' }}>
          <h5>Complete the form for add new Tenant</h5>
      <Form>
        <Form.Group controlId="tenantName" style={{ paddingTop: '8px', color:'black' }}>
          <Form.Label>Tenant Name:</Form.Label>
          <Form.Control
            className="sa-input"
            type="text"
            value={input.tenantName}
            onChange={(e) => handleChange(e)}
            placeholder="Name for the new tenant"
            style={input.tenantName? { borderColor: "#899AF1",color:'black' }:{borderColor: "#899AF1"}}
          />
        </Form.Group>
        <Form.Group controlId="country" style={{ paddingTop: '15px', color:'black' }}>
          <Form.Label>Country:</Form.Label>
          <Form.Control
            as="select"
            className="sa-input"
            value={input.country}
            onChange={(e) => handleChange(e)}
            style={input.country? { borderColor: "#899AF1",color:'black' }:{borderColor: "#899AF1"}}
          >
            <option value="" disabled>Select a country</option>
            {countries.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </Form.Control>
        </Form.Group>
       {messageError ?  <Form.Label style={{paddingTop:'5px',color:'red',fontWeight:'bold'}}>Complete the fields</Form.Label> : null}
      </Form>
    </Modal.Body>
    ) : (
<>
    <Modal.Body style={{ color: 'black' }}>
          <h5>Select the tenant you want to watch</h5>
          <div style={{ display: 'flex', alignItems: 'center' }}>
  <p style={{ paddingTop: '8px', marginRight: '10px' }}>Current tenant:</p>
  <p style={{ paddingTop: '8px',fontWeight: 'bolder' }}>{currentTenant}</p>
</div>
          <div>
            <select
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              style={{ borderColor: '#899AF1', borderRadius: '5px', height: '45px', width: '100%', fontSize: '1rem' }}
            >
              <option value="default" disabled>
                Select your tenant
              </option>
              {allTenants !== undefined ? (
                allTenants.map((el) => (
                  <option key={el.idTenant} value={el.idTenant}>
                    {el.tenantName} 
                  </option>
                ))
              ) : (
                <option value="default" disabled>
                  {' '}
                </option>
              )}
            </select>
          </div>
        </Modal.Body>
        <Modal.Body style={{ color: 'black' }}>
          <h5 style={{ paddingBottom: '15px' }}>SuperAdmins in Tenants</h5>
          <div style={{ maxHeight: '320px', overflowY: 'auto', overflowX: 'auto', border: '1px solid #899AF1', borderRadius: '3px' }}>
            <table className="superadmin-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f2f2f2' }}>
                <tr>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ccc' }}>Email</th>
                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #ccc' }}>Tenant</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ccc' }}>Tenant Name</th>
                </tr>
              </thead>
              <tbody>
                {allSuperAd && allSuperAd.map((superAdmin) => (
                  <tr key={superAdmin.idTenant} style={{ borderBottom: '1px solid #ccc' }}>
                    <td style={{ padding: '5px', borderBottom: '1px solid #ccc' }}>{superAdmin.userEmail}</td>

                    <td className="tenant-cell" style={{ padding: '5px', textAlign: 'center', borderBottom: '1px solid #ccc' }}>
                      {superAdmin.idTenant}
                    </td>
                    <td style={{ padding: '15px', borderBottom: '1px solid #ccc' }}>{superAdmin.nameTenant}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </>
      )}

    <Modal.Footer>
      <Button variant="secondary" style={{ minWidth: '140px' }} onClick={() => dispatch(closeModal())}>
        Close
      </Button>
      {addTenant ? (
        <Button variant="primary" style={{ minWidth: '140px' }} onClick={() => submitNewTenant()}>
          Add new tenant
        </Button>
      ) : (
        <Button variant="primary" style={{ minWidth: '140px' }} onClick={() => handleTenantStatus()}>
          Apply changes
        </Button>
      )}
    </Modal.Footer>
  </>
);
};
export default SuperAdminStatus;